import { v4 as uuidv4 } from 'uuid'
import type { PlanImageCardCreateDTO, PlanImageCardDTO, PlanImageCardModifyDTO } from '@mutations'
import {
  DEFAULT_PLAN_IMAGE_CARD_BORDER_STYLE,
  DEFAULT_PLAN_IMAGE_CARD_CONFIG,
  DEFAULT_PLAN_IMAGE_CARD_NAME,
  DEFAULT_PLAN_IMAGE_CARD_TEXT_STYLE,
  DEFAULT_PLAN_IMAGE_CARD_WIDTH_CM,
} from 'src/domain/planImageCards/defaults'
import type { PlanImageCard, PlanImageCardInput } from 'src/domain/planImageCards/types'

export const completePlanImageCardInput = (input: PlanImageCardInput): PlanImageCard => ({
  id: input.id || uuidv4(),
  name: input.name ?? DEFAULT_PLAN_IMAGE_CARD_NAME,
  position: input.position,
  fileGuid: input.fileGuid,
  titleLines: input.titleLines ?? [DEFAULT_PLAN_IMAGE_CARD_NAME],
  width: input.width ?? DEFAULT_PLAN_IMAGE_CARD_WIDTH_CM,
  planConfig: input.planConfig ?? { ...DEFAULT_PLAN_IMAGE_CARD_CONFIG },
  textStyle: input.textStyle ?? { ...DEFAULT_PLAN_IMAGE_CARD_TEXT_STYLE },
  borderStyle: input.borderStyle ?? { ...DEFAULT_PLAN_IMAGE_CARD_BORDER_STYLE },
  dateCreated: input.dateCreated ?? new Date().toISOString(),
  dateModified: input.dateModified ?? new Date().toISOString(),
})

export const planImageCardDtoToPlanImageCard = (dto: PlanImageCardDTO): PlanImageCard => ({
  id: dto.id,
  name: dto.name,
  position: dto.position,
  fileGuid: dto.fileGuid,
  titleLines: dto.titleLines,
  width: dto.width,
  planConfig: dto.planConfig,
  textStyle: dto.textStyle ?? {},
  borderStyle: dto.borderStyle ?? {},
  dateCreated: dto.dateCreated,
  dateModified: dto.dateModified,
})

export const planImageCardToCreateDTO = (card: PlanImageCard): PlanImageCardCreateDTO => ({
  id: card.id,
  name: card.name,
  position: card.position,
  fileGuid: card.fileGuid,
  titleLines: card.titleLines,
  width: card.width,
  textStyle: card.textStyle,
  borderStyle: card.borderStyle,
  planConfig: card.planConfig,
})

export const planImageCardToModifyDTO = (card: PlanImageCard): PlanImageCardModifyDTO => {
  const { id: _id, ...dto } = planImageCardToCreateDTO(card)
  return dto
}
